import React, { useState } from 'react';
import { Typography } from '@mui/material';
import BackdropDialog from 'common/components/BackdropDialog';
import { BatchManager } from 'common/frontend/firebase/firestore';
import { api } from 'common/frontend/api';
import { useTranslation } from 'services/localization';

interface Props {
	categoryIds: string[];
	onClose: () => void;
}
const DeleteCategoriesDialog = (props: Props) => {
	const { t } = useTranslation();
	const { categoryIds, onClose } = props;
	const [isDeleting, setIsDeleting] = useState<boolean>(false);

	const handleDeleteCategories = async () => {
		setIsDeleting(true);
		const batchManager = new BatchManager();

		categoryIds.forEach((id) => {
			api(batchManager.batch()).productCategories.doc(id).delete();
		});

		await batchManager.commit();
		setIsDeleting(false);
	};

	return (
		<BackdropDialog
			isOpen={true}
			onClose={onClose}
			variant="danger"
			label={t('DeleteCategoriesDialog.title', {
				categoryCount: categoryIds.length,
				defaultValue: 'Delete {{categoryCount}} categories?',
			})}
			body={
				<Typography>
					{t('DeleteCategoriesDialog.description', {
						categoryCount: categoryIds.length,
						defaultValue:
							'Are you sure you want to delete the {{categoryCount}} selected categories? This action cannot be undone.',
					})}
				</Typography>
			}
			confirm={{
				label: t('common:actions.yesDelete', 'Yes, delete'),
				callback: handleDeleteCategories,
				closeAfterDone: true,
				loading: isDeleting,
			}}
			cancel={{
				label: t('common:actions.noCancel', 'No, cancel'),
				callback: onClose,
			}}
		/>
	);
};

export default DeleteCategoriesDialog;
